import { render, staticRenderFns } from "./PcIdxNum3MContent.vue?vue&type=template&id=2dd8674f&"
import script from "./PcIdxNum3MContent.vue?vue&type=script&lang=js&"
export * from "./PcIdxNum3MContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports